import { useStrategyStore } from '../../../store/strategy-store/strategy-store';
import { SideSectionSelectedEntity } from '../initiative-list/side-section/side-section-selected-entity';

export function OutcomesSideSection() {
  const selectedOutcome = useStrategyStore((state) => state.selectedOutcome);

  if (!selectedOutcome) {
    return null;
  }

  return <SideSectionSelectedEntity entity={selectedOutcome} entityType="outcome" />;
}
